export default __webpack_public_path__ + "7219e46ac3cd6b2da6d1ff4d28ca91c2.png";